var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitingListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 13.997,
    viewBox: "0 0 19 13.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "queue_music_black_24dp_1_",
    "data-name": "queue_music_black_24dp (1)",
    d: "M14,6H4A1,1,0,0,0,4,8H14a1,1,0,0,0,0-2Zm0,4H4a1,1,0,0,0,0,2H14a1,1,0,0,0,0-2ZM4,16h6a1,1,0,0,0,0-2H4a1,1,0,0,0,0,2ZM19,6a2.006,2.006,0,0,0-2,2v6.18A3,3,0,1,0,19,17V8h2a1,1,0,0,0,0-2Z",
    transform: "translate(-3 -6)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingListIcon);
export default __webpack_public_path__ + "static/media/waiting-list-icon.ffb896dccc79dfb066180a0502710945.svg";
export { ForwardRef as ReactComponent };